import React from 'react';
import { Box, Typography, InputBase, InputAdornment, IconButton } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { CenteredBox } from './centered-box';

const GradientBanner = ({
    title,
    subtitle,
    placeholder,
    searchTerm,
    onSearchChange,
    isMobile,
    isTablet,
    height = '450px',
    paddingY = '40px',
    paddingBottom = '40px',
    className = '',
}) => {
    return (
        <Box
            display="flex"
            alignItems="center"
            justifyItems="center"
            flexDirection="column"
            paddingY={paddingY}
            paddingBottom={paddingBottom}
            sx={{
                width: '100%',
                borderRadius: '4px',
                background: 'linear-gradient(132deg, #FA96C3 -2.07%, #FF669B 15.82%, #BD8DE8 116.64%)',
                height: height,
                position: 'relative',
            }}
            className={className}
        >
            <CenteredBox sx={{ margin: 'auto' }}>
                <Typography variant="h3" align="center" color="white" gutterBottom>
                    {title}
                </Typography>
                <Typography variant="h6" align="center" color="white" fontWeight={400} sx={{ marginBottom: '24px' }}>
                    {subtitle}
                </Typography>
                <Box
                    display="flex"
                    alignItems="center"
                    width="100%"
                    position="relative"
                    sx={{
                        backgroundColor: searchTerm ? 'white' : 'transparent',
                        borderRadius: '8px',
                        transition: 'backgroundColor 0.2s',
                        padding: isTablet ? 2 : 0,
                    }}
                    className="search-container"
                >
                    <InputBase
                        fullWidth
                        placeholder={placeholder}
                        value={searchTerm}
                        onChange={onSearchChange}
                        endAdornment={
                            <InputAdornment position="end">
                                <IconButton>
                                    <SearchIcon sx={{ color: searchTerm ? 'black' : 'white' }} />
                                </IconButton>
                            </InputAdornment>
                        }
                        sx={{
                            p: 1,
                            borderRadius: 8,
                            border: 'none',
                            color: searchTerm ? 'black' : 'white',
                            paddingLeft: '14px',
                            background: 'rgba(255,255,255,0.1)',
                            '&::placeholder': { color: 'white' },
                            '& .MuiInputBase-input': { color: searchTerm ? 'black' : 'white' },
                        }}
                    />
                </Box>
            </CenteredBox>
        </Box>
    );
};

export default GradientBanner;
